<template>
  <div>
    <div class="pcBox" v-if="ifPc">
      <div class="header">
        <img src="../assets/images/logo.png" alt />
      </div>
      <div class="bannerBox">
        <div class="qrcode-tip-box" v-show="tipShow"></div>
        <p class="qrcode-tip" v-show="tipShow">
          目前暂不支持支付宝/微信扫码下载，敬请谅解！
          <span class="close-tip icon-close" @click="closeTip"></span>
        </p>
        <div class="bannerWords">
          <p class="bannerTitle">星火燎原 集萃成裘</p>
          <p class="bannerContent">
            星集App定位于信息中介平台，锁定中小型商户和用户，实现商户和商户商户和用户，
            用户和用户之间的串联；打通境内商户和境内商户，境内商户和境外商户，境外商户
            和境外商户，最终目标是更加牢固的锁定场景、渠道和支付。
          </p>
          <div class="downLoadApk">
            <!-- <div class="downLoadBox">
            <img class="qrcode" src="../assets/images/erweima.png" alt />
            <span class="downLoadQrcode">ios下载</span>
            </div>-->
            <div class="downLoadBox">
              <!-- <img class="qrcode" :src="src" alt @click="downLoadAndroid" /> -->
              <div class="qrcode" id="qrCode" ref="qrCodeDiv"></div>
              <span class="downLoadQrcode">Android下载</span>
            </div>
          </div>
        </div>
        <img class="banner" src="../assets/images/banner2@2x.png" alt />
        <img class="phone" src="../assets/images/phone 9@2x.png" alt />
      </div>
      <div class="decollate title">APP页面展示</div>
      <p class="bigLine"></p>
      <div class="showBox">
        <img src="../assets/images/show 8@2x.png" alt />
      </div>
      <div class="footer">
        <div class="flexItem">
          <img src="../assets/images/company 5@2x.png" alt />
          <p class="title">公司名称</p>
          <p class="line"></p>
          <p class="note">上海宜揉网络科技有限公司</p>
        </div>
        <div class="flexItem">
          <img src="../assets/images/address 6@2x.png" alt />
          <p class="title">公司地址</p>
          <p class="line"></p>
          <p class="note">上海市徐汇区宜山路1289号7幢608室</p>
        </div>
        <div class="flexItem">
          <img src="../assets/images/telephone 7@2x.png" alt />
          <p class="title">联系电话</p>
          <p class="line"></p>
          <p class="note">4000128128</p>
        </div>
      </div>
    </div>
    <div class="wapBox" v-if="!ifPc">
      <div class="header">
        <img src="../assets/images/logo.png" alt />
      </div>
      <div class="bannerBox">
        <div class="qrcode-tip-box" v-show="tipShow"></div>
        <p class="qrcode-tip" v-show="tipShow">
          目前暂不支持支付宝/微信扫码下载，敬请谅解！
          <span class="close-tip icon-close" @click="closeTip"></span>
        </p>
        <div class="bannerWords">
          <p class="bannerTitle">星火燎原 集萃成裘</p>
          <div class="downLoadApk">
            <!-- <div class="downLoadBox">
            <img class="qrcode" src="../assets/images/erweima.png" alt />
            <span class="downLoadQrcode">ios下载</span>
            </div>-->
            <div class="downLoadBox">
              <!-- <img class="qrcode" :src="src" alt @click="downLoadAndroid" /> -->
              <div class="qrcode" id="qrCode" ref="qrCodeDiv"></div>
              <span class="downLoadQrcode">Android下载</span>
            </div>
          </div>
        </div>
        <img class="banner" src="../assets/images/banner2@2x.png" alt />
        <img class="phone" src="../assets/images/phone 9@2x.png" alt />
      </div>
      <div class="decollate title">万商星集APP</div>
      <p class="bigLine"></p>
      <p class="bannerContent">
        星集App定位于信息中介平台，锁定中小型商户和用户，实现商户和商户商户和用户，
        用户和用户之间的串联；打通境内商户和境内商户，境内商户和境外商户，境外商户
        和境外商户，最终目标是更加牢固的锁定场景、渠道和支付。
      </p>

      <div class="showBox">
        <img src="../assets/images/show 8@2x.png" alt />
      </div>
      <div class="footer">
        <div class="flexItem">
          <img src="../assets/images/company 5@2x.png" alt />
          <p class="title">公司名称</p>
          <p class="line"></p>
          <p class="note">上海宜揉网络科技有限公司</p>
        </div>
        <div class="flexItem">
          <img src="../assets/images/address 6@2x.png" alt />
          <p class="title">公司地址</p>
          <p class="line"></p>
          <p class="note">上海市徐汇区宜山路1289号7幢608室</p>
        </div>
        <div class="flexItem">
          <img src="../assets/images/telephone 7@2x.png" alt />
          <p class="title">联系电话</p>
          <p class="line"></p>
          <p class="note">4000128128</p>
        </div>
      </div>
    </div>
    <div class="icp">
      <p>CopyRight © 上海宜揉网络科技有限公司出品</p>
      <p class="ICPImg" @click="goToIcp">
        <img
          src="../assets/images/ic_national_emblem@2x.png"
          alt
          width="24"
        />沪ICP备19017130号-3
      </p>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
export default {
  name: "index",
  data() {
    return {
      ifPc: true,
      tipShow: true,
    };
  },
  methods: {
    closeTip() {
      this.tipShow = false;
    },
    goToIcp() {
      console.log(window);
      window.open("https://beian.miit.gov.cn/", "_blank");
    },
  },
  mounted() {
    let href;
    if (window.location.host == "192.168.31.11:8080") {
      href = "http://192.168.14.31:8080/app/android/xingji.apk";
    } else {
      href =
        window.location.protocol +
        "//" +
        window.location.host +
        "/app/android/xingji.apk";
    }

    if (window.screen.width > 1024) {
      this.ifPc = true;
      new QRCode(this.$refs.qrCodeDiv, {
        text: href,
        width: 100,
        height: 100,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
    } else {
      this.ifPc = false;
      new QRCode(this.$refs.qrCodeDiv, {
        text: href,
        width: 55,
        height: 55,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
    }
  },
};
</script>
<style scoped lang="less">
@media only screen and (max-width: 1024px) {
  .header {
    padding: 10px 0 2px 0;
    img {
      width: 75px;
    }
  }
  .bigLine {
    height: 1px;
    background: #ff5502;
    margin: 8px 20px -3px 20px;
  }
  .bannerBox {
    position: relative;
    min-height: 300px;
    width: 100%;
    .qrcode-tip-box {
      height: 19px;
      background: rgba(255, 207, 68, 1);
      opacity: 0.4;
      position: absolute;
      width: 100%;
      top: 0px;
    }
    .qrcode-tip {
      margin: 0 auto;
      width: 100%;
      color: white;
      position: absolute;
      font-size: 12px;
    }
    .close-tip {
      font-size: 14px;
      font-weight: 700;
      position: absolute;
      right: 13px;
      bottom: 0;
      cursor: pointer;
      width: 18px;
      height: 18px;
      background: url("../assets/images/icon_delete.png");
    }
    .banner {
      width: 100%;
    }
    .phone {
      position: absolute;
      top: 8%;
      z-index: 2;
      right: 10%;
      width: 30%;
    }
    .bannerTitle {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 6%;
    }
    .bannerWords {
      position: absolute;
      top: 3%;
      z-index: 2;
      left: 10%;
      width: 45%;
      font-size: 20px;
      color: white;
      text-align: left;
    }

    .downLoadQrcode {
      font-size: 12px;
      font-weight: 700;
      margin-left: -2px;
    }
    .qrcode {
      width: 55px;
      border: 3px solid #fff;
    }
  }
  .decollate {
    font-weight: 700;
    margin-top: -20px;
  }
  .showBox {
    background: #ffeec3;
    padding-top: 20px;
    img {
      width: 90%;
    }
  }
  .bannerContent {
    padding: 0 20px;
    text-align: left;
    font-size: 14px;
    color: #333333;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }
  .flexItem {
    p {
      padding: 0;
      margin: 5px 0;
    }
    margin: 20px 0;
    img {
      width: 54px;
      height: 54px;
    }
    .title {
      font-weight: 700;
      font-size: 16px;
    }
    .line {
      width: 150px;
      height: 1px;
      background: #ff5502;
      margin: 0 auto;
    }
    .note {
      font-size: 14px;
    }
  }
}
@media only screen and (min-width: 1025px) {
  .header {
    text-align: left;
    margin-left: 15%;
    height: 40px;
    padding: 20px 0;
  }
  .bigLine {
    width: 80%;
    height: 1px;
    background: #ff5502;
    margin: 0 auto;
    margin-top: 20px;
  }
  .bannerBox {
    position: relative;
    width: 100%;
    min-height: 300px;
    .qrcode-tip-box {
      height: 30px;
      background: rgba(255, 207, 68, 1);
      opacity: 0.4;
      position: absolute;
      width: 100%;
      top: 0px;
    }
    .qrcode-tip {
      margin: 0 auto;
      width: 100%;
      color: white;
      position: absolute;
      font-size: 14px;
      line-height: 30px;
    }
    .close-tip {
      font-size: 20px;
      font-weight: 700;
      position: absolute;
      top: 6px;
      right: 13px;
      cursor: pointer;
      width: 18px;
      height: 18px;
      background: url("../assets/images/icon_delete.png");
    }
    .banner {
      width: 100%;
    }
    .phone {
      position: absolute;
      top: 14%;
      z-index: 2;
      right: 15%;
      width: 25%;
    }
    .bannerTitle {
      font-size: 40px;
      font-weight: bold;
      margin-bottom: 10%;
    }
    .bannerWords {
      position: absolute;
      top: 6%;
      z-index: 2;
      left: 15%;
      width: 37%;
      font-size: 20px;
      color: white;
      text-align: left;
    }
  }
  .decollate {
    margin-top: -60px;
  }
  .showBox {
    img {
      width: 100%;
    }
    margin: 0 auto;
    width: 80%;
  }
  .footer {
    width: 100%;
    display: flex;
    margin-bottom: 20px;
    div.flexItem {
      flex: 1;
      .line {
        width: 300px;
        height: 1px;
        background: #ff5502;
        margin: 0 auto;
      }
      .note {
        font-size: 16px;
      }
    }
  }
  .title {
    color: #333;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 28px;
  }
  .downLoadBox {
    position: relative;
    font-size: 16px;
    float: left;
    margin-top: 5%;
    left: 0;
    .qrcode {
      margin-right: 50px;
      border: 5px solid #fff;
    }
    .downLoadQrcode {
      position: absolute;
      left: 50%;
      bottom: -32px;
      margin-left: -70px;
      font-weight: 700;
    }
  }
  .icp {
    height: 100px;
    background: #fbfbfb;
    font-size: 12px;
    padding-top: 25px;
    img {
      position: relative;
      top: 5px;
      margin-right: 5px;
    }
    .ICPImg {
      margin-top: -10px;
      cursor: pointer;
    }
  }
}
</style>
